import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { selectAllFormSettings } from "../../../redux/slices/formSettingsSlice";
import { selectAllP2pSettings } from "../../../redux/slices/p2pSettingsSlice";
import { selectReceipt } from "../../../redux/slices/receiptSlice";
import { selectCmsControlById } from "../../../redux/slices/cmsSettingsSlice";
import {
    selectAppSettings,
    setAppEmailModalOpen,
} from "../../../redux/slices/appSettingsSlice";
import EmailSharingModal from "./EmailSharingModal";

const CmsConnectedEmailSharingModal = ({ controlId }) => {
    const appSettings = useSelector(selectAppSettings);
    const { emailModalOpen } = appSettings;
    const receipt = useSelector(selectReceipt);
    const { transaction } = receipt;
    const transactionId = transaction.id;
    const control = useSelector((state) =>
        selectCmsControlById(controlId, state),
    );
    const {
        options: {
            additionalText = "",
            cancelButtonLabel = "Cancel",
            defaultMessageContent = "Hey! I'm fundraising for %EventName%! You could join me! Want to sign-up?",
            defaultSubjectContent = "I'm fundraising for %EventName%",
            emailLabel = "Friend's Email",
            heading = "Email A Friend",
            linkFinePrint = "Link to campaign will be sent with message.",
            messageLabel = "Message",
            subjectLabel = "Subject",
            submitButtonLabel = "Send Email",
        },
    } = control;
    const formSettings = useSelector(selectAllFormSettings);
    const p2pSettings = useSelector(selectAllP2pSettings);
    const { name } = formSettings;
    const { alias } = p2pSettings;

    const emailSharingModalProps = {
        controlId,
        additionalText,
        cancelButtonLabel,
        defaultMessageContent: defaultMessageContent.replace(
            "%EventName%",
            name,
        ),
        defaultSubjectContent: defaultSubjectContent.replace(
            "%EventName%",
            name,
        ),
        emailLabel,
        heading,
        linkFinePrint,
        messageLabel,
        subjectLabel,
        submitButtonLabel,
        emailModalOpen,
        alias,
        transactionId,
        setAppEmailModalOpen,
    };

    return <EmailSharingModal {...emailSharingModalProps} />;
};

CmsConnectedEmailSharingModal.propTypes = {
    controlId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
        .isRequired,
};

export default CmsConnectedEmailSharingModal;
